<template>
    <div class="configurator">
        <div class="configurator__wrap">
            <app-controlhead
                :title="controlhead.title"
                :help="controlhead.help"
                :show-close="true"
                :show-remove="showRemove"
                :show-save="showSave"
                :show-global="controlhead.showGlobal"
                :remove-text="controlhead.removeText"
                @close="close"
                @remove="remove"
            ></app-controlhead>

            <div class="configurator__content">
                <div v-if="getActiveConfiguratorGroup === 'modules'">
                    <component
                        v-bind:is="'app-' + getActiveConfiguratorView + '-' + getActiveModuleType"
                        v-bind:module-id="getActiveModuleId"
                        v-bind:listitem-id="getActiveListitemId"
                        @controlhead="controlhead = $event"
                    ></component>
                </div>
                <div v-if="getActiveConfiguratorGroup === 'menus'">
                    <component
                        v-bind:is="'app-' + getActiveConfiguratorView + '-' + getActiveMenuType"
                        v-bind:menu-id="getActiveMenuId"
                        v-bind:listitem-id="getActiveListitemId"
                        @controlhead="controlhead = $event"
                    ></component>
                </div>
            </div>
        </div>

        <div class="configurator__buttons">
            <button
                v-on:click.prevent="saveAndClose"
                :disabled="buttonDisabled"
                class="button button--icon-checkmark"
            >
                Übernehmen &amp; Schließen
            </button>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { OpenedRouteMixin } from '@/mixins/OpenedRouteMixin';
import Controlhead from '@/components/assorted/Controlhead';

import AboutData from '@/components/configurator/data/About.vue';
import AboutAppearance from '@/components/configurator/appearance/About.vue';
import AboutLayout from '@/components/configurator/layout/About.vue';
import AboutWidgetData from '@/components/configurator/data/AboutWidget.vue';
import AboutWidgetAppearance from '@/components/configurator/appearance/AboutWidget.vue';
import AboutWidgetLayout from '@/components/configurator/layout/AboutWidget.vue';
import AlbumData from '@/components/configurator/data/Album.vue';
import AlbumAppearance from '@/components/configurator/appearance/Album.vue';
import AlbumLayout from '@/components/configurator/layout/Album.vue';
import AwardsData from '@/components/configurator/data/Awards.vue';
import AwardsAppearance from '@/components/configurator/appearance/Awards.vue';
import AwardsLayout from '@/components/configurator/layout/Awards.vue';
import BrandsData from '@/components/configurator/data/Brands.vue';
import BrandsAppearance from '@/components/configurator/appearance/Brands.vue';
import BrandsLayout from '@/components/configurator/layout/Brands.vue';
import CertificationsData from '@/components/configurator/data/Certifications.vue';
import CertificationsAppearance from '@/components/configurator/appearance/Certifications.vue';
import CertificationsLayout from '@/components/configurator/layout/Certifications.vue';
import ContactData from '@/components/configurator/data/Contact.vue';
import ContactAppearance from '@/components/configurator/appearance/Contact.vue';
import ContactLayout from '@/components/configurator/layout/Contact.vue';
import ContactFormData from '@/components/configurator/data/ContactForm.vue';
import ContactFormAppearance from '@/components/configurator/appearance/ContactForm.vue';
import ContactFormLayout from '@/components/configurator/layout/ContactForm.vue';
import ContactWidgetData from '@/components/configurator/data/ContactWidget.vue';
import ContactWidgetAppearance from '@/components/configurator/appearance/ContactWidget.vue';
import ContactWidgetLayout from '@/components/configurator/layout/ContactWidget.vue';
import DocumentsData from '@/components/configurator/data/Documents.vue';
import DocumentsAppearance from '@/components/configurator/appearance/Documents.vue';
import DocumentsLayout from '@/components/configurator/layout/Documents.vue';
import GalleryData from '@/components/configurator/data/Gallery.vue';
import GalleryAppearance from '@/components/configurator/appearance/Gallery.vue';
import GalleryLayout from '@/components/configurator/layout/Gallery.vue';
import ImageSliderData from '@/components/configurator/data/ImageSlider.vue';
import ImageSliderAppearance from '@/components/configurator/appearance/ImageSlider.vue';
import ImageSliderLayout from '@/components/configurator/layout/ImageSlider.vue';
import ImageTextData from '@/components/configurator/data/ImageText.vue';
import ImageTextAppearance from '@/components/configurator/appearance/ImageText.vue';
import ImageTextLayout from '@/components/configurator/layout/ImageText.vue';
import ImprintAppearance from '@/components/configurator/appearance/Imprint.vue';
import ImprintLayout from '@/components/configurator/layout/Imprint.vue';
import JobsData from '@/components/configurator/data/Jobs.vue';
import JobsAppearance from '@/components/configurator/appearance/Jobs.vue';
import JobsLayout from '@/components/configurator/layout/Jobs.vue';
import JobsWidgetData from '@/components/configurator/data/JobsWidget.vue';
import JobsWidgetAppearance from '@/components/configurator/appearance/JobsWidget.vue';
import JobsWidgetLayout from '@/components/configurator/layout/JobsWidget.vue';
import ListingData from '@/components/configurator/data/Listing.vue';
import ListingAppearance from '@/components/configurator/appearance/Listing.vue';
import ListingLayout from '@/components/configurator/layout/Listing.vue';
import NewsAppearance from '@/components/configurator/appearance/News.vue';
import NewsLayout from '@/components/configurator/layout/News.vue';
import OpeningTimesData from '@/components/configurator/data/OpeningTimes.vue';
import OpeningTimesAppearance from '@/components/configurator/appearance/OpeningTimes.vue';
import OpeningTimesLayout from '@/components/configurator/layout/OpeningTimes.vue';
import PartnersData from '@/components/configurator/data/Partners.vue';
import PartnersAppearance from '@/components/configurator/appearance/Partners.vue';
import PartnersLayout from '@/components/configurator/layout/Partners.vue';
import PrivacyAppearance from '@/components/configurator/appearance/Privacy.vue';
import PrivacyLayout from '@/components/configurator/layout/Privacy.vue';
import ReferencesData from '@/components/configurator/data/References.vue';
import ReferencesAppearance from '@/components/configurator/appearance/References.vue';
import ReferencesLayout from '@/components/configurator/layout/References.vue';
import ReferencesWidgetData from '@/components/configurator/data/ReferencesWidget.vue';
import ReferencesWidgetAppearance from '@/components/configurator/appearance/ReferencesWidget.vue';
import ReferencesWidgetLayout from '@/components/configurator/layout/ReferencesWidget.vue';
import SectorsData from '@/components/configurator/data/Sectors.vue';
import SectorsAppearance from '@/components/configurator/appearance/Sectors.vue';
import SectorsLayout from '@/components/configurator/layout/Sectors.vue';
import SectorsWidgetData from '@/components/configurator/data/SectorsWidget.vue';
import SectorsWidgetAppearance from '@/components/configurator/appearance/SectorsWidget.vue';
import SectorsWidgetLayout from '@/components/configurator/layout/SectorsWidget.vue';
import ServicesData from '@/components/configurator/data/Services.vue';
import ServicesAppearance from '@/components/configurator/appearance/Services.vue';
import ServicesLayout from '@/components/configurator/layout/Services.vue';
import SocialsData from '@/components/configurator/data/Socials.vue';
import SocialsAppearance from '@/components/configurator/appearance/Socials.vue';
import SocialsLayout from '@/components/configurator/layout/Socials.vue';
import TeamData from '@/components/configurator/data/Team.vue';
import TeamAppearance from '@/components/configurator/appearance/Team.vue';
import TeamLayout from '@/components/configurator/layout/Team.vue';
import TeamWidgetData from '@/components/configurator/data/TeamWidget.vue';
import TeamWidgetAppearance from '@/components/configurator/appearance/TeamWidget.vue';
import TeamWidgetLayout from '@/components/configurator/layout/TeamWidget.vue';
import TextBoxData from '@/components/configurator/data/TextBox.vue';
import TextBoxAppearance from '@/components/configurator/appearance/TextBox.vue';
import TextBoxLayout from '@/components/configurator/layout/TextBox.vue';
import VideoData from '@/components/configurator/data/Video.vue';
import VideoAppearance from '@/components/configurator/appearance/Video.vue';
import VideoLayout from '@/components/configurator/layout/Video.vue';
import WidgetsData from '@/components/configurator/data/Widgets.vue';
import WidgetsAppearance from '@/components/configurator/appearance/Widgets.vue';
import WidgetsLayout from '@/components/configurator/layout/Widgets.vue';

import HeaderData from '@/components/configurator/data/Header.vue';
import HeaderAppearance from '@/components/configurator/appearance/Header.vue';
import HeaderLayout from '@/components/configurator/layout/Header.vue';
import FooterAppearance from '@/components/configurator/appearance/Footer.vue';
import FooterLayout from '@/components/configurator/layout/Footer.vue';

export default {
    data() {
        return {
            controlhead: {}
        };
    },
    components: {
        'app-controlhead': Controlhead,

        'app-data-about': AboutData,
        'app-appearance-about': AboutAppearance,
        'app-layout-about': AboutLayout,
        'app-data-aboutwidget': AboutWidgetData,
        'app-appearance-aboutwidget': AboutWidgetAppearance,
        'app-layout-aboutwidget': AboutWidgetLayout,
        'app-data-album': AlbumData,
        'app-appearance-album': AlbumAppearance,
        'app-layout-album': AlbumLayout,
        'app-data-awards': AwardsData,
        'app-appearance-awards': AwardsAppearance,
        'app-layout-awards': AwardsLayout,
        'app-data-brands': BrandsData,
        'app-appearance-brands': BrandsAppearance,
        'app-layout-brands': BrandsLayout,
        'app-data-certifications': CertificationsData,
        'app-appearance-certifications': CertificationsAppearance,
        'app-layout-certifications': CertificationsLayout,
        'app-data-contact': ContactData,
        'app-appearance-contact': ContactAppearance,
        'app-layout-contact': ContactLayout,
        'app-data-contactform': ContactFormData,
        'app-appearance-contactform': ContactFormAppearance,
        'app-layout-contactform': ContactFormLayout,
        'app-data-contactwidget': ContactWidgetData,
        'app-appearance-contactwidget': ContactWidgetAppearance,
        'app-layout-contactwidget': ContactWidgetLayout,
        'app-data-documents': DocumentsData,
        'app-appearance-documents': DocumentsAppearance,
        'app-layout-documents': DocumentsLayout,
        'app-data-gallery': GalleryData,
        'app-appearance-gallery': GalleryAppearance,
        'app-layout-gallery': GalleryLayout,
        'app-data-imageslider': ImageSliderData,
        'app-appearance-imageslider': ImageSliderAppearance,
        'app-layout-imageslider': ImageSliderLayout,
        'app-data-imagetext': ImageTextData,
        'app-appearance-imagetext': ImageTextAppearance,
        'app-layout-imagetext': ImageTextLayout,
        'app-appearance-imprint': ImprintAppearance,
        'app-layout-imprint': ImprintLayout,
        'app-data-jobs': JobsData,
        'app-appearance-jobs': JobsAppearance,
        'app-layout-jobs': JobsLayout,
        'app-data-jobswidget': JobsWidgetData,
        'app-appearance-jobswidget': JobsWidgetAppearance,
        'app-layout-jobswidget': JobsWidgetLayout,
        'app-data-listing': ListingData,
        'app-appearance-listing': ListingAppearance,
        'app-layout-listing': ListingLayout,
        'app-appearance-news': NewsAppearance,
        'app-layout-news': NewsLayout,
        'app-data-openingtimes': OpeningTimesData,
        'app-appearance-openingtimes': OpeningTimesAppearance,
        'app-layout-openingtimes': OpeningTimesLayout,
        'app-data-partners': PartnersData,
        'app-appearance-partners': PartnersAppearance,
        'app-layout-partners': PartnersLayout,
        'app-appearance-privacy': PrivacyAppearance,
        'app-layout-privacy': PrivacyLayout,
        'app-data-references': ReferencesData,
        'app-appearance-references': ReferencesAppearance,
        'app-layout-references': ReferencesLayout,
        'app-data-referenceswidget': ReferencesWidgetData,
        'app-appearance-referenceswidget': ReferencesWidgetAppearance,
        'app-layout-referenceswidget': ReferencesWidgetLayout,
        'app-data-sectors': SectorsData,
        'app-appearance-sectors': SectorsAppearance,
        'app-layout-sectors': SectorsLayout,
        'app-data-sectorswidget': SectorsWidgetData,
        'app-appearance-sectorswidget': SectorsWidgetAppearance,
        'app-layout-sectorswidget': SectorsWidgetLayout,
        'app-data-services': ServicesData,
        'app-appearance-services': ServicesAppearance,
        'app-layout-services': ServicesLayout,
        'app-data-socials': SocialsData,
        'app-appearance-socials': SocialsAppearance,
        'app-layout-socials': SocialsLayout,
        'app-data-team': TeamData,
        'app-appearance-team': TeamAppearance,
        'app-layout-team': TeamLayout,
        'app-data-teamwidget': TeamWidgetData,
        'app-appearance-teamwidget': TeamWidgetAppearance,
        'app-layout-teamwidget': TeamWidgetLayout,
        'app-data-textbox': TextBoxData,
        'app-appearance-textbox': TextBoxAppearance,
        'app-layout-textbox': TextBoxLayout,
        'app-data-video': VideoData,
        'app-appearance-video': VideoAppearance,
        'app-layout-video': VideoLayout,
        'app-data-widgets': WidgetsData,
        'app-appearance-widgets': WidgetsAppearance,
        'app-layout-widgets': WidgetsLayout,

        'app-data-header': HeaderData,
        'app-appearance-header': HeaderAppearance,
        'app-layout-header': HeaderLayout,
        'app-appearance-footer': FooterAppearance,
        'app-layout-footer': FooterLayout
    },
    methods: {
        ...mapActions([
            'routeRemoveQuery',
            'forgetDifferInRoute',
            'saveAllData',
            'removeModule',
            'scrollVerticalCenterModule'
        ]),
        async save() {
            await this.forgetDifferInRoute(this.openedRoute);
            await this.saveAllData();
        },
        async saveAndClose() {
            await this.save();
            await this.close();
        },
        async close() {
            let module_id = this.getActiveModuleId;
            await this.routeRemoveQuery([
                'configurator',
                'configurator_group',
                'configurator_view',
                'module_id',
                'menu_id',
                'textpicker',
                'textpicker_namespace',
                'filemanager',
                'filemanager_source',
                'filemanager_accept',
                'filemanager_multiple',
                'fileeditor',
                'fileeditor_file_id'
            ]);
            if (module_id !== null) {
                this.scrollVerticalCenterModule({ id: module_id });
            }
        },
        async remove() {
            await this.removeModule({
                id: this.getActiveModuleId,
                confirm: true,
                route: true,
                save: true
            });
        }
    },
    computed: {
        ...mapGetters([
            'getActiveConfiguratorGroup',
            'getActiveModuleId',
            'getActiveListitemId',
            'getActiveModuleType',
            'getActiveConfiguratorView',
            'getActiveMenuId',
            'getActiveMenuType',
            'getCurrentRouteFullPath',
            'differHasChangesInRoute',
            'differHasInvalidFieldsInRoute',
            'isModuleDeletable'
        ]),
        showSave() {
            return (
                this.differHasChangesInRoute(this.openedRoute) &&
                !this.differHasInvalidFieldsInRoute(this.openedRoute)
            );
        },
        buttonDisabled() {
            return this.differHasInvalidFieldsInRoute(this.openedRoute);
        },
        showRemove() {
            return this.isModuleDeletable(this.getActiveModuleId);
        }
    },
    mixins: [OpenedRouteMixin],
    created() {
        this.controlhead = {};
    },
    watch: {
        openedRoute(newValue, oldValue) {
            if (oldValue !== null) {
                this.controlhead = {};
            }
        }
    }
};
</script>
